module.exports = __webpack_public_path__ + "img/img_14@2x.c42689e2.png";